import React, { useEffect, useRef, useState } from 'react';
import proptypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import {
  Button, Drawer, DrawerHeader
} from '@one-thd/sui-atomic-components';
import { triggerAnalytics } from '../helpers';
import {
  PROJECT_CREATE_BUTTON_CLICKED,
  PROJECT_CREATE_OVERLAY,
  PROJECTS_INTERACTION
} from '../constants';
import { CreateAProjectContent } from './CreateAProjectContent';

const { func, bool, string } = proptypes;

export const CreateAProject = (props) => {

  const {
    CustomCreateProjectActionElement,
    projectId,
    onCreate,
    isCopyProject,
    isSharedProject
  } = props;

  const createProjectBtnRef = useRef(null);
  const hasCompletedSubmissionRef = useRef(false);

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.trigger('CreateAProject.ready');
  }, []);

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open && createProjectBtnRef.current) {
      createProjectBtnRef.current.blur();
    }

    if (open) {
      triggerAnalytics(PROJECT_CREATE_OVERLAY, {});
    }
  }, [open]);

  const handleOpen = () => {
    hasCompletedSubmissionRef.current = false;
    triggerAnalytics(PROJECT_CREATE_BUTTON_CLICKED, {});
    setOpen(true);
  };

  const handleClose = () => {
    if (!hasCompletedSubmissionRef.current) {
      triggerAnalytics(PROJECTS_INTERACTION, { action: 'close-create-new-project-overlay' });
    }
    setOpen(false);
  };

  const handleCreate = (createdProject) => {
    hasCompletedSubmissionRef.current = true;
    onCreate(createdProject);
  };

  return (
    <div className="sui-flex sui-justify-center" data-component="CreateAProject">
      {CustomCreateProjectActionElement
        ? <CustomCreateProjectActionElement onClick={handleOpen} ref={createProjectBtnRef} />
        : (
          <Button
            fullWidth
            variant="primary"
            onClick={handleOpen}
            aria-label="Create Project"
            data-testid="create-new-project"
            ref={createProjectBtnRef}
          >
            Create Project
          </Button>
        )}
      <Drawer open={open} onClose={handleClose}>
        <DrawerHeader title="Create Project" onClose={handleClose} />
        <CreateAProjectContent projectId={projectId} onCreate={handleCreate} handleClose={handleClose} />
      </Drawer>
    </div>
  );
};

CreateAProject.propTypes = {
  // callback when user clicks the form button
  // return parameters: { id, projectAccessType, project }
  onCreate: func.isRequired,
  isCopyProject: bool,
  projectId: string,
  isSharedProject: bool,
  CustomCreateProjectActionElement: func,
};

CreateAProject.defaultProps = {
  isCopyProject: false,
  projectId: null,
  isSharedProject: false,
  CustomCreateProjectActionElement: null,
};

CreateAProject.displayName = 'CreateAProject';

CreateAProject.dataModel = extend(CreateAProjectContent);
